package com.bikompanion.ui.home

import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberUpdatedState
import androidx.compose.ui.Modifier
import androidx.lifecycle.viewmodel.navigation3.rememberViewModelStoreNavEntryDecorator
import androidx.navigation3.runtime.NavEntry
import androidx.navigation3.runtime.rememberSaveableStateHolderNavEntryDecorator
import androidx.navigation3.ui.NavDisplay

/**
 * Hosts the home screen's [backStack] in a `NavDisplay`, drawing [content] as the map entry.
 *
 * [content] is read through a State because `NavDisplay` keeps the entry it first built: a lambda
 * closed over this composition's parameters would go on drawing the values from the first one.
 */
@Composable
internal fun HomeNavHost(
    backStack: List<HomeRoute>,
    onBack: () -> Unit,
    modifier: Modifier = Modifier,
    content: @Composable () -> Unit,
) {
    val currentContent by rememberUpdatedState(content)
    val sceneStrategies = remember { listOf(HomeSceneStrategy()) }
    NavDisplay(
        backStack = backStack,
        modifier = modifier.fillMaxSize(),
        onBack = onBack,
        entryDecorators = listOf(
            rememberSaveableStateHolderNavEntryDecorator(),
            rememberViewModelStoreNavEntryDecorator(),
        ),
        sceneStrategies = sceneStrategies,
        entryProvider = { route ->
            NavEntry(route) {
                // A station entry draws nothing of its own: see HomeScene.
                if (route is MapRoute) currentContent()
            }
        },
    )
}
